<template>
  <b-container fluid>
    <b-row>
      <b-col sm="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Danh sách khách hàng</h4>
          </template>
          <template v-slot:body>
            <b-button v-b-modal.modal-1 variant="primary" class="mb-4 mt-2">
              <i class="las la-plus-circle"/> Tạo KH mới
            </b-button>
            <div class="table-responsive">
              <b-table
                id="customer-list-table"
                ref="customerListTableRef"
                :items="listState"
                :fields="customerFields"
                :striped="false"
                :outlined="true"
                :small="true"
                :hover="true"
                :busy.sync="isBusy"
                :primary-key="'id'"
                class="table-striped table-bordered mt-1 col-lg-8"
                role="grid"
                aria-describedby="user-list-page-info"
              >
                <template v-slot:cell(status)="data">
                  <b-badge v-if="data.item.status === '1'" variant="primary">Đang hoạt động</b-badge>
                  <b-badge v-else variant="danger">Khóa</b-badge>
                </template>
                <template v-slot:cell(action)="data">
                  <div class="flex align-items-center list-user-action">
                    <a
                      class="iq-bg-primary"
                      data-toggle="tooltip"
                      data-placement="top"
                      title
                      data-original-title=""
                      v-b-modal.modal-2
                      @click="emitEditData(data.item.id, data.item.name, data.item.status)"
                    >
                      <i class="las la-pen-alt"></i>
                    </a>
                    <a
                      class="iq-bg-primary"
                      data-toggle="tooltip"
                      data-placement="top"
                      title
                      data-original-title="Xem chi tiết"
                      @click="removeCustomer(data.item.id, data.item.name)"
                    >
                      <i class="las la-trash-alt text-red"></i>
                    </a>
                  </div>
                </template>
              </b-table>
            </div>
            <customer-creator-modal id="modal-1"/>
            <customer-editor-modal id="modal-2" :edit-data="editData"/>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { findash } from '../../config/pluginInit'
import { mapActions, mapGetters } from 'vuex'
import CustomerCreatorModal from '../../components/application/customer/CustomerCreatorModal'
import CustomerEditorModal from '../../components/application/customer/CustomerEditorModal'
import api from '../../store/api'

export default {
  name: 'CustomerList',
  components: { CustomerCreatorModal, CustomerEditorModal },
  async mounted () {
    findash.index()
  },
  async created () {
  },
  data () {
    return {
      isBusy: false,
      customerFields: [
        {
          key: 'name',
          label: 'Tên KH'
        },
        {
          key: 'status',
          label: 'Trạng thái',
          class: 'text-center',
          thStyle: { width: '20%' }
        },
        {
          key: 'action',
          label: '',
          class: 'text-center',
          thStyle: { width: '20%' }
        }
      ],
      customerList: [],
      modal: {
        customer_name: null,
        customer_status: 1
      },
      editData: {
        customer_name: null,
        customer_status: 1,
        customer_id: null
      }
    }
  },
  computed: {
    ...mapGetters({
      listState: 'Customer/listState',
      'serverError': 'Setting/serverErrorsState'
    })
  },
  methods: {
    ...mapActions({
      loadList: 'Customer/loadList'
    }),
    emitEditData (id, name, status) {
      this.editData = {
        customer_id: id,
        customer_name: name,
        customer_status: status
      }
    },
    removeCustomer (customerId, name) {
      this.$swal({
        title: name,
        text: 'Bạn chắc chắn xóa khách hàng này ?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Xóa',
        denyButtonText: `Hủy`
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          api.customer.delete(customerId).then(async () => {
            this.$swal({
              icon: 'success',
              title: 'Xóa thành công'
            })

            // load list
            await this.loadList()
          }).catch(() => {
            this.$swal({
              icon: 'error',
              title: 'Lỗi...',
              text: this.serverError
            })
          })
        } else if (result.isDenied) {

        }
      })
    }
  }
}
</script>
